import { motion } from 'framer-motion';
import { Mic, MicOff, StopCircle, XCircle, Clock } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface AudioControlsProps {
  isRecording: boolean;
  setIsRecording: (recording: boolean) => void;
  onEndSession: () => void;
  disabled?: boolean;
  className?: string;
}

export function AudioControls({
  isRecording,
  setIsRecording,
  onEndSession,
  disabled,
  className,
}: AudioControlsProps) {
  const { t } = useTranslation();
  const [recordingDuration, setRecordingDuration] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isRecording) {
      interval = setInterval(() => {
        setRecordingDuration((prev) => prev + 1);
      }, 1000);
    } else {
      setRecordingDuration(0);
    }
    return () => clearInterval(interval);
  }, [isRecording]);

  const formatDuration = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div className={className}>
      <div className="flex justify-center items-center">
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={onEndSession}
          className="px-4 lg:px-6 py-2 lg:py-3 bg-red-600 text-white rounded-full flex items-center space-x-2 hover:bg-red-700 transition-all hover:shadow-lg shadow-md text-sm lg:text-base font-medium"
          disabled={disabled}
        >
          <StopCircle className="w-4 lg:w-5 h-4 lg:h-5" />
          <span>{t('custom.roleplay.buttons.endSession')}</span>
        </motion.button>
      </div>
    </div>
  );
}
